module.exports = __webpack_public_path__ + "static/media/19.1b028e3c.jpg";